import { useCallback, useState } from 'react';

/** Persisted state hook backed by localStorage (JSON-serialised). */
export function useLocalStorage<T>(key: string, initial: T): [T, (value: T) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? (JSON.parse(raw) as T) : initial;
    } catch {
      return initial;
    }
  });

  const set = useCallback(
    (value: T) => {
      setState(value);
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {
        /* storage unavailable — keep in-memory only */
      }
    },
    [key],
  );

  return [state, set];
}
